export const fontFamilies = {
  default: 'Apercu, Arial, sans-serif',
  mono: 'Apercu Mono, monospace'
};
export const getFontFamily = family => fontFamilies[family];
export const fontFamily = fontFamilies.default;
export const fontWeights = {
  feather: 300,
  // light
  base: 400,
  // normal
  heavy: 700 // bold
};
export const fontSizes = {
  0: '0.75rem',
  // 12px
  1: '0.875rem',
  // 14px
  2: '1rem',
  // 16px
  3: '1.25rem',
  // 20px
  4: '1.5rem',
  // 24px
  5: '2rem',
  // 32px
  6: '2.5rem',
  // 40px
  7: '3rem',
  // 48px
  8: '3.75rem' // 60px
};
export const getFontWeight = weight => fontWeights[weight];
export const getFontSize = size => fontSizes[size];